module.exports = __webpack_public_path__ + "static/media/29EUNOG9.5dd375c1.jpg";